import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  ImageListItem,
  ImageListItemBar,
  IconButton,
  Paper,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import DndKit from "../dragNDrop/DndKit";

const PREFIX = "OrderEntities";

const classes = {
  tileWidth: `${PREFIX}-tileWidth`,
  title: `${PREFIX}-title`,
  titleBar: `${PREFIX}-titleBar`,
  scrollContainer: `${PREFIX}-scrollContainer`,
  imageItem: `${PREFIX}-imageItem`,
};

const StyledDiv = styled("div")(({ theme }) => ({
  [`& .${classes.tileWidth}`]: {
    width: "inherit",
    maxWidth: "100%",
    maxHeight: "100%",
    height: "auto",
    marginBottom: "1.5rem",
  },

  [`& .${classes.title}`]: {
    color: theme.palette.primary.light,
    fontSize: "0.8rem",
  },

  [`& .${classes.titleBar}`]: {
    background:
      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)",
    "& > div": {
      marginLeft: "5px",
    },
  },

  [`& .${classes.scrollContainer}`]: {
    marginBottom: "2rem",
    display: "flex",
    overflow: "auto",
    "&::-webkit-scrollbar": {
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "rgb(181 154 79 / 58%)",
      borderRadius: "10px",
    },
  },

  [`& .${classes.imageItem}`]: {
    width: "150px",
    height: "200px !important",
    maxHeight: "200px",
    backgroundColor: "#434343",
  },
}));

const OrderEntities = (props) => {
  const [elements, setElements] = useState([]);

  useEffect(() => {
    if (props.elements) {
      setElements(props.elements);
    }
  }, []);

  useEffect(() => {
    if (props.elements) {
      setElements(props.elements);
    }
  }, [props.elements]);

  const handleSaveOrderedArray = (newArr) => {
    setElements(newArr);
    props.setOrder(newArr);
  };

  return (
    <StyledDiv>
      <Paper elevation={10} className={classes.scrollContainer}>
        <DndKit
          mode={"horizontal"}
          data={elements}
          dragTopLeft
          customWidth
          reorderedArray={(newArray) => handleSaveOrderedArray(newArray)}
          renderItem={(elem, index) => (
            <StyledDiv>
              <ImageListItem
                key={
                  elem.id
                    ? `campaign-${elem.id}-${index}`
                    : `exparience-${elem._id}-${index}`
                }
                className={classes.imageItem}
              >
                <img
                  src={elem.logoUrl}
                  alt={elem.name}
                  className={classes.tileWidth}
                />
                <ImageListItemBar
                  title={elem.name}
                  classes={{
                    root: classes.titleBar,
                    title: classes.title,
                  }}
                  actionIcon={
                    <IconButton
                      onClick={() => props.deleteTile(elem)}
                      size="small"
                    >
                      <Delete />
                    </IconButton>
                  }
                />
              </ImageListItem>
            </StyledDiv>
          )}
        />
      </Paper>
    </StyledDiv>
  );
};

export default OrderEntities;
